import { resolveCategoryCommission } from "./publicSitePricingCommission";

function toFinite(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function sanitizeQuantity(quantity) {
  const q = toFinite(quantity);
  if (q == null || q <= 0) return 1;
  return q;
}

function emitPublicPriceSsotTrace(_payload) {
  /* ingest logging removed */
}

function resolveProductCategory(productType) {
  if (productType === "hotel" || productType === "hotel_room") return "hotel";
  if (productType === "flight") return "flight";
  return "vacation_package";
}

export function resolvePublicDisplayPrice({
  productType,
  agentFinalPrice,
  publicSitePricingSettings,
  quantity = 1,
  currency = "ILS",
  context = {},
}) {
  const normalizedQuantity = sanitizeQuantity(quantity);
  const agent = toFinite(agentFinalPrice);
  const normalizedProductType = String(productType || "vacation_package");

  const proGateExplicitlyFalse =
    context?.isPublicSiteActive === false ||
    context?.isAgentPro === false ||
    context?.publicMode === false;
  if (proGateExplicitlyFalse) {
    const out = {
      status: "public_site_inactive_or_not_pro",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      currency,
      quantity: normalizedQuantity,
      fallbackUsed: false,
      source: "public_display_price_ssot",
      context,
    };
    emitPublicPriceSsotTrace({
      action: "resolve_display_price",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      fallbackUsed: false,
      status: out.status,
      source: out.source,
    });
    return out;
  }

  if (agent == null || agent <= 0) {
    const out = {
      status: "invalid_agent_price",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      currency,
      quantity: normalizedQuantity,
      fallbackUsed: false,
      source: "public_display_price_ssot",
      context,
    };
    emitPublicPriceSsotTrace({
      action: "resolve_display_price",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      fallbackUsed: false,
      status: out.status,
      source: out.source,
    });
    return out;
  }

  if (!publicSitePricingSettings || typeof publicSitePricingSettings !== "object") {
    const out = {
      status: "waiting_for_public_pricing_settings",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      currency,
      quantity: normalizedQuantity,
      fallbackUsed: false,
      source: "public_display_price_ssot",
      context,
    };
    emitPublicPriceSsotTrace({
      action: "resolve_display_price",
      productType: normalizedProductType,
      agentFinalPrice: agent,
      commissionType: null,
      commissionValue: null,
      commissionAmount: null,
      publicFinalPrice: null,
      fallbackUsed: false,
      status: out.status,
      source: out.source,
    });
    return out;
  }

  const commissionCategory = resolveProductCategory(normalizedProductType);
  const commission = resolveCategoryCommission(publicSitePricingSettings, commissionCategory);
  const commissionType = commission?.type ?? "fixed";
  const commissionValueRaw = toFinite(commission?.value);
  const commissionValue = commissionValueRaw != null && commissionValueRaw > 0 ? commissionValueRaw : 0;
  const commissionAmount =
    commissionType === "percent"
      ? (agent * commissionValue) / 100
      : commissionValue * normalizedQuantity;
  const publicFinalPrice = agent + commissionAmount;

  const out = {
    status: "ready",
    productType: normalizedProductType,
    agentFinalPrice: agent,
    commissionType,
    commissionValue,
    commissionAmount,
    publicFinalPrice,
    currency,
    quantity: normalizedQuantity,
    fallbackUsed: false,
    source: "public_display_price_ssot",
    context,
  };
  emitPublicPriceSsotTrace({
    action: "resolve_display_price",
    productType: normalizedProductType,
    agentFinalPrice: agent,
    commissionType,
    commissionValue,
    commissionAmount,
    publicFinalPrice,
    fallbackUsed: false,
    status: out.status,
    source: out.source,
  });
  return out;
}

